const CANVAS_PIXEL_RATIO = typeof window !== "undefined" ? Math.ceil(window.devicePixelRatio * 2) / 2 : 1;

export { CANVAS_PIXEL_RATIO };
//# sourceMappingURL=canvas.js.map
